import { DateTime, Interval } from 'luxon';

import { Days } from '../store/entities';

export function compareTimeArrays(a: number[], b?: number[]): boolean {
  if (!b && isMidnight(a)) {
    return true;
  }
  if (!b) {
    b = toTimeArrayFromDate(DateTime.local());
  }
  return toDateFromTimeArray(a) > toDateFromTimeArray(b);
}

export function getSlotTiming([hours, minutes]: number[]): {startTime: number[], endTime: number[]} {
  const now = DateTime.local();
  const endDate = now.plus({ hours, minutes });
  return {
    startTime: toTimeArrayFromDate(now),
    endTime: toTimeArrayFromDate(endDate),
  };
}

export function getCurrentDay(): Days {
  return Days[
    new Intl.DateTimeFormat('en-GB', { weekday: 'long' })
      .format(new Date())
      .toUpperCase()
    ];
}

export function getIntervalBetweenTimeArrays(startTime: number[], endTime: number[]): Interval {
  const startDateTime = toDateFromTimeArray(startTime);
  const endDateTime = toDateFromTimeArray(endTime, true);
  return Interval.fromDateTimes(startDateTime, endDateTime);
}

function isMidnight(arr: number[] = []): boolean {
  return arr.length && arr.reduce((acc, c) => acc += c, 0) === 0;
}

function toDateFromTimeArray(arr?: number[], addOneDay: boolean = false): DateTime {
  if (!arr || !arr.length) {
    return DateTime.local();
  }
  if (isMidnight(arr)) {
    const midnight = DateTime.fromObject({ hour: 0 }).toLocal();
    return addOneDay ? midnight.plus({ day: 1 }) : midnight;
  }
  const [hour, minute, second, millisecond] = arr;
  return DateTime.fromObject({ hour, minute, second, millisecond }).toLocal();
}

export function toTimeArrayFromDate(date: DateTime): number[] {
  const { hour, minute } = date.toObject();
  return [hour, minute, 0, 0];
}

export function buildListWithLength(length: number): number[] {
  return Array.apply(null, { length }).map(Number.call, Number);
}
